export class Job {
  id: number;
  state: string;
  output_info: any;
  error: string; 

  constructor(id: number, state: string, output_info: any, error:string) {
      this.id = id;
      this.state = state;
      this.output_info = output_info;
      this.error = error;
  }

  clone(): Job {
      return new Job(this.id, this.state, this.output_info, this.error);
  }
}
